import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';  
import "../../Styles/ViewMoreDetails.css";
import Loader from "../../Components/Loader"; 

function ViewMoreDetails() {
  const [activeTab, setActiveTab] = useState('faculty');
  const [facultyData, setFacultyData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); 

  const fetchFacultyData = async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setError("No authentication token found.");
        return;
      }

      const response = await axios.get('https://api.uniums.com/api/admin/faculty-view-details', {
        headers: { Authorization: `Bearer ${token}` },
      });

      setFacultyData(response.data.data || []);  // Default to empty array if no data
    } catch (error) {
      console.error('Error fetching faculty data:', error);
      setError("Error fetching faculty data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudentData = async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setError("No authentication token found.");
        return;
      }

      const response = await axios.get('https://api.uniums.com/api/admin/student-view-details', {
        headers: { Authorization: `Bearer ${token}` },
      });

      setStudentData(response.data.data || []);  // Default to empty array if no data
    } catch (error) {
      console.error('Error fetching student data:', error);
      setError("Error fetching student data.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([fetchFacultyData(), fetchStudentData()]);
    };
    fetchData();
  }, []);

  const handleViewDetails = (personId) => {
    const route = activeTab === 'faculty'
      ? `/faculty-attendance-details/${personId}`
      : `/student-attendance-details/${personId}`;

    navigate(route);
  };



  const renderTable = (data) => {
    if (!Array.isArray(data)) {
      return <p>No data available</p>;
    }

    return (
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>User Code</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((person) => (
            <tr key={person._id}>
              <td>{person.name}</td>
              <td>{person.employeeCode}</td>
              <td className='td_view_more_btn'>
                <button className='view_more_details' onClick={() => handleViewDetails(person._id)}>
                  View Details
                </button>
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="ViewMoreDetails">
      <h1>View Attendance Details</h1>
      <div className="tabs_new">
        <button
          className={`tab_new ${activeTab === 'faculty' ? 'active' : ''}`}
          onClick={() => setActiveTab('faculty')}
        >
          Faculty
        </button>
        <button
          className={`tab_new ${activeTab === 'student' ? 'active' : ''}`}
          onClick={() => setActiveTab('student')}
        >
          Student
        </button>
      </div>

      <div className="tab_new-content">
        {loading ? (
          <Loader />
        ) : error ? (
          <p>{error}</p>
        ) : (
          <>
            {activeTab === 'faculty' && renderTable(facultyData)}
            {activeTab === 'student' && renderTable(studentData)}
          </>
        )}
      </div>
    </div>
  );
}

export default ViewMoreDetails;
